import HttpService from '../HttpService';

export default class PermissionService {
  constructor() {
    this._httpService = new HttpService('/servicos/permissao');
  }

  async FetchPermissions() {
    return await this._httpService.get('');
  }
}
